import React, {useEffect, useState} from 'react';
import {Box, Button, Card, CardContent, Stack, Container, Typography} from '@mui/material';
import AdminNavbar from "./AdminNavbar";
import Cookies from 'js-cookie';
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { format, parseISO } from 'date-fns';
import QueueForm from "./QueueForm";

function Dashboard({}) {

    const [queues, setQueues] = useState([]);
    const [loading, setLoading] = useState(true);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedQueue, setSelectedQueue] = useState(null);

    const formatDate = (dateString) => {
        try {
            return format(parseISO(dateString), 'MMM dd yyyy, h:mma');
        } catch {
            return dateString;
        }
    };

    const columns = [
        { field: 'queueId', headerName: 'ID', width: 90, flex: 0.7 },
        { field: 'capacity', headerName: 'Capacity', width: 100, flex: 1 },
        { field: 'totalVisitors', headerName: 'Total Visitors', width: 130, flex: 1.2 },
        { field: 'isActive', headerName: 'Active', width: 80, flex: 1 },
        { field: 'isCancelled', headerName: 'Cancelled', width: 80, flex: 1 },
        { field: 'startTime', headerName: 'Start Time', width: 180, flex: 1.5, valueFormatter: (params) => formatDate(params.value)},
        { field: 'endTime', headerName: 'End Time', width: 180, flex: 1.5, valueFormatter: (params) => formatDate(params.value)},
        {
            field: 'edit',
            headerName: 'Edit',
            sortable: false,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleEdit(params.row)}
                >
                    Edit
                </Button>
            ),
            width: 100
        },
        {
            field: 'manage',
            headerName: 'Manage',
            sortable: false,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="secondary"
                    disabled={!params.row.isActive}
                    onClick={() => goToManage(params.row.queueId)}
                >
                    Manage
                </Button>
            ),
            width: 100
        },
    ];

    const handleEdit = (queue) => {
        setSelectedQueue(queue);
        setIsModalOpen(true);
    };

    const goToManage = (queueId) => {
        window.location.href = `/staff/active/${queueId}`;
    };

    // Function to fetch queues from the API
    const fetchQueues = async () => {
        try {
            const csrfToken = Cookies.get('XSRF-TOKEN');
            const response = await axios.get('/api/queues/staff', {
                headers: {
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            setQueues(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching queues', error);
            setLoading(false);
        }
    };

    // Fetch queues on component mount
    useEffect(() => {
        fetchQueues();
    }, []);

    useEffect(() => {
        if(!isModalOpen){
            setSelectedQueue(null);
        }
    }, [isModalOpen]);

    const handleAdd = () => {
        setSelectedQueue(null); // null for adding a new queue
        setIsModalOpen(true);
    };

    const handleSave = async (queue) => {
        const csrfToken = Cookies.get('XSRF-TOKEN');
        const headers = { 'X-CSRF-TOKEN': csrfToken };

        try {
            if (selectedQueue) {
                // Update existing queue
                await axios.put(`/api/queues/staff/${queue.queueId}`, queue, { headers });
            } else {
                // Add new queue
                await axios.post('/api/queues/staff', queue, { headers });
            }
            fetchQueues(); // Refresh the queue list
        } catch (error) {
            console.error('Error saving queue', error);
            // Handle errors (e.g., show an error message)
        }
    };

    const handleDelete = async (queueId) => {
        const csrfToken = Cookies.get('XSRF-TOKEN');
        const headers = { 'X-CSRF-TOKEN': csrfToken };

        try {
            await axios.delete(`/api/queues/staff/${queueId}`, { headers });
            fetchQueues(); // Refresh the queue list
        } catch (error) {
            console.error('Error deleting queue', error);
            // Handle errors (e.g., show an error message)
        }
    };

    return (
        <Container padding={2}>
            <QueueForm
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                queueData={selectedQueue}
                onSave={handleSave}
                onDelete={handleDelete}
            />
            <Box sx={{display: 'flex', justifyContent: 'space-between', margin: 3}}>
                <Typography align="center" sx={{fontSize: '1.3rem', fontWeight: 600, padding: '10px 5px'}}>
                    Starry Night All Queues
                </Typography>
                <Button variant="contained" color="success" onClick={handleAdd} sx={{height: '45px'}}>
                    + Add Queue
                </Button>
            </Box>
            <Box margin={1} sx={{display: 'flex', alignItems: 'center'}}>
                <Card elevation={3} rounded="true" sx={{flexGrow: 1}}>
                    <DataGrid
                        rows={queues}
                        columns={columns}
                        pageSize={10}
                        loading={loading}
                        rowsPerPageOptions={[10]}
                        getRowId={(row) => row.queueId}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'startTime', sort: 'desc' }],
                            },
                        }}
                    />
                </Card>
            </Box>

        </Container>

    );
}

export default Dashboard;